import React from 'react';
import { Link } from 'react-router-dom';
import { getPluralSuffix } from '../../../../utils/plurals';

/**
 * @typedef {object} RecentUpdatesNotificationCardProps
 * @property {string} [name]
 * @property {string} [label]
 * @property {string} [redirectUrl]
 * @property {number} [notificationDaysAgo]
 */

/**
 * @param {RecentUpdatesNotificationCardProps} props
 */
const RecentUpdatesNotificationCard = props => {
  const { name, label, redirectUrl, notificationDaysAgo } = props;

  const daysAgoText =
    notificationDaysAgo <= 0
      ? 'Today'
      : `${notificationDaysAgo} day${getPluralSuffix(notificationDaysAgo)} ago`;

  return (
    <div className='notification-card'>
      <div className='notification-card__title'>
        <div className='notification-card__name'>
          <Link to={redirectUrl} className='notification__link'>
            {name}
          </Link>
        </div>
        <div className='notification-card__info'>{label}</div>
      </div>
      <div className='notification-card__date'>{daysAgoText}</div>
    </div>
  );
};

export default RecentUpdatesNotificationCard;
